import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '@Scatt';

class CefrScore extends TimelineSegmentContentDataBase {
  constructor(
    score = null,
    scoreReason = '',
    aspects = [],
    unratableReasonId = '0',
    unratableReason = CefrScore.unratableReasons['0'],
  ) {
    super();
    this.score = score;
    this.scoreReason = scoreReason;
    this.aspects = aspects;
    this.unratableReasonId = unratableReasonId;
    this.unratableReason = unratableReason;
  }

  static generateFromRawObj(cefrScoreRawObj) {
    return new this(
      cefrScoreRawObj['score'],
      cefrScoreRawObj['score_reason'],
      [ ...cefrScoreRawObj['aspects'] ],
      cefrScoreRawObj['unratable_reason_id'],
      cefrScoreRawObj['unratable_reason'],
    );
  }

  generateRawObj() {
    let cefrScoreRawObj = {};
    cefrScoreRawObj['score'] = this.score;
    cefrScoreRawObj['score_reason'] = this.scoreReason;
    cefrScoreRawObj['aspects'] = [ ...this.aspects ];
    cefrScoreRawObj['unratable_reason_id'] = this.unratableReasonId;
    cefrScoreRawObj['unratable_reason'] = this.unratableReason;
    return cefrScoreRawObj;
  }

  clone() {
    return new this.constructor(
      this.score,
      this.scoreReason,
      [ ...this.aspects ],
      this.unratableReasonId,
      this.unratableReason,
    );
  }

  isSameAs(that) {
    if (this.score !== that.score) return false;
    if (this.scoreReason !== that.scoreReason) return false;
    let numAspects = this.aspects.length;
    for (let aspectIdx = 0; aspectIdx < numAspects; ++aspectIdx) {
      if (this.aspects[aspectIdx] !== that.aspects[aspectIdx]) {
        return false;
      }
    }
    if (this.unratableReasonId !== that.unratableReasonId) return false;
    if (this.unratableReason !== that.unratableReason) return false;
    return true;
  }

  get isUnratable() {
    return this.unratableReasonId !== '0';
  }

  get isScoringDone() {
    if (this.unratableReasonId === '0') {
      if (this.score === null) return false;
      if (this.scoreReason.trim().length === 0) return false;
    }
    if (this.unratableReasonId === '99') {
      if (this.unratableReason.trim().length === 0) return false;
    }
    return true;
  }
}

Object.defineProperty(
  CefrScore,
  'unratableReasons',
  {
    value: {
      '0': 'Ratable',
      '1': 'Unratable: Confusing questions',
      '2': 'Unratable: Too many interruptions',
      '3': 'Unratable: Misunderstanding of student’s response',
      '4': 'Unratable: Technical problems',
      '5': 'Unratable: Failure to elicit student’s upper limit',
      '99': 'Unratable: Other',
    },
    writable: false,
  },
)

class CefrScoreSegmentData extends TimelineSegmentDataBase {
  static contentData = CefrScore;

  constructor(begin, end, cefrScore, isLocked) {
    super(begin, end, cefrScore, isLocked);
  }

  static toString() {
    return 'CefrScoreSegmentData';
  }

  static get name() {
    return 'CEFR Score Data';
  }

  clone() {
    return super.clone(false);
  }
}

export default CefrScoreSegmentData;
